import React, { createContext } from "react";
import { CatalogCategory } from "../Models/BuildGameTypes";

export interface GameItem {
  id: string;
  image: string;
  title: string;
  width: number;
  coins: number;
  price: number;
  level: number;
  locked: boolean;
  quantity: number;
}

export interface CharacterType {
  characterId: string;
  name: string;
  level: number;
  collectedCount: number;
  unlocked: boolean;
  position: { x: number; y: number; tileX?: number; tileY?: number };
  spriteSheetUrl: string; // Add this
  spriteData: any; // Adjust type according to your sprite data structure
  frameRate: number;
  scale: number;
  coinsMultiplier: number;
  world: string;
  probability: number;
}

export interface GameDataContextType {
  coinCount: number;
  /** True once the first resources fetch has settled. */
  dataReady?: boolean;
  moonrockCount: number;
  addItem: (item: GameItem) => void;
  buyItem: (itemPrice: number) => boolean;
  addMoonrock: (amount: number) => void;
  addCoins: (amount: number) => void;

  showGrid: boolean;
  setShowGrid: React.Dispatch<React.SetStateAction<boolean>>;
  unlockedCharacters: CharacterType[];
  setUnlockedCharacters: React.Dispatch<React.SetStateAction<CharacterType[]>>; // Correct type for setUnlockedCharacters

  fetchCharacterData: () => void;
  unlockCharacter: (characterId: string) => void;
  starsCount: number;
  setStarsCount: React.Dispatch<React.SetStateAction<number>>;
  setMoonrockCount: React.Dispatch<React.SetStateAction<number | null>>;
  setCoinCount: React.Dispatch<React.SetStateAction<number | null>>;

  starCountdown: number; // seconds until next regen star (0 if capped)
  setStarCountdown: React.Dispatch<React.SetStateAction<number>>;

  refreshStars: () => Promise<void>;
  setLastStarTimestamp: React.Dispatch<React.SetStateAction<number>>;
  setStarMeta: React.Dispatch<
    React.SetStateAction<{ regenSeconds: number; cap: number }>
  >;

  starMeta: { regenSeconds: number; cap: number };
  lastStarTimestamp: number;

  unlockedItems: number[][];
  fetchUnlockedItems: () => void;

  buildCategories: CatalogCategory[];
  fetchBuildCatalog: () => void;

  itemHierarchies: any[];
  userId: string;
  fetchUserId: () => void;
  fetchNotifications: () => void;
  pendingNotifications: string[];
  setPendingNotifications: React.Dispatch<React.SetStateAction<string[]>>;
  updateNotifications: () => void;

  // Better to be in a new context
  fetchSearchedUsers: (usernameSearch: string) => Promise<any[]>; // string of users found by search
}

// Create the context with a default null value
const GameDataContext = createContext<GameDataContextType | null>(null);
const GameItemDataContext = createContext<GameItem | null>(null);

export { GameItemDataContext };
export default GameDataContext;
